export type CardValueScale = 'default' | 'compact' | 'hero';

/** Base classes for numeric values inside cards — always pair with cardValueClass(). */
export const CARD_VALUE_BASE =
  'card-value min-w-0 max-w-full font-semibold tabular-nums tracking-tight leading-tight';

export const CARD_SUBVALUE_BASE = 'card-value min-w-0 max-w-full font-medium tabular-nums leading-snug';

function pickByLength(len: number, bands: [number, string, string, string, string]): string {
  const [, s, m, l, xl] = bands;
  if (len <= bands[0]) return s;
  if (len <= bands[0] + 2) return m;
  if (len <= bands[0] + 5) return l;
  return xl;
}

const SCALE_BANDS: Record<CardValueScale, [number, string, string, string, string]> = {
  default: [6, 'text-lg sm:text-2xl', 'text-base sm:text-xl', 'text-sm sm:text-lg', 'text-xs sm:text-base'],
  compact: [5, 'text-base sm:text-lg', 'text-sm sm:text-base', 'text-xs sm:text-sm', 'text-[10px] sm:text-xs'],
  hero: [8, 'text-2xl sm:text-3xl', 'text-xl sm:text-2xl', 'text-lg sm:text-xl', 'text-sm sm:text-lg'],
};

/** Tailwind size classes that shrink as the formatted value gets longer. */
export function cardValueClass(value: string, scale: CardValueScale = 'default'): string {
  const len = String(value ?? '').trim().length;
  return pickByLength(len, SCALE_BANDS[scale]);
}

export function cardSubValueClass(value: string): string {
  const len = String(value ?? '').trim().length;
  if (len <= 10) return 'text-xs text-zinc-500';
  if (len <= 16) return 'text-[11px] text-zinc-500';
  return 'text-[10px] text-zinc-500';
}
